import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import win1 from '../assets/images/win1.jpg';
import impact from '../assets/images/impact.jpg';
import hurricane from '../assets/images/hurr.jpg';
import modern from '../assets/images/mod.jpg';
import sliding from '../assets/images/slide.jpg';

const Products = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Products' },
    { id: 'windows', name: 'Impact Windows' },
    { id: 'doors', name: 'Impact Doors' },
    { id: 'sliding', name: 'Sliding Glass Doors' },
  ];

  const products = [
    {
      id: 1,
      name: 'Premium Impact Window',
      category: 'windows',
      price: 7999.99,
      image: modern,
      description: 'High-performance impact window with enhanced hurricane protection',
      features: [
        'Miami-Dade County Approved',
        'Energy Star Certified',
        'Noise Reduction',
        'UV Protection'
      ]
    },
    {
      id: 2,
      name: 'Hurricane Impact Door',
      category: 'doors',
      price: 8999.99,
      image: hurricane,
      description: 'Maximum protection entry door with superior storm resistance',
      features: [
        'Multi-point Locking System',
        'Reinforced Frame',
        'Water Infiltration Protection',
        'Enhanced Security Features'
      ]
    },
    {
      id: 3,
      name: 'Sliding Glass Door System',
      category: 'sliding',
      price: 12499.99,
      image: sliding,
      description: 'Modern sliding glass door system with smooth operation',
      features: [
        'Hurricane Rated',
        'Thermal Insulation',
        'Smooth Gliding System',
        'Security Lock System'
      ]
    },
    {
      id: 4,
      name: 'Classic Impact Window',
      category: 'windows',
      price: 7499.99,
      image: win1,
      description: 'Traditional style impact window perfect for any room',
      features: [
        'High Impact Resistance',
        'Colonial Style Design',
        'Easy Maintenance',
        'Lifetime Warranty'
      ]
    },
    {
      id: 5,
      name: 'Premium French Door',
      category: 'doors',
      price: 9999.99,
      image: impact,
      description: 'Elegant French door system with impact resistance',
      features: [
        'Double Door Design',
        'Decorative Glass Options',
        'Enhanced Security',
        'Weather-Tight Seal'
      ]
    },
    {
      id: 6,
      name: 'Modern Casement Window',
      category: 'windows',
      price: 8499.99,
      image: modern,
      description: 'Contemporary casement window with maximum ventilation',
      features: [
        'Easy Operation',
        'Maximum Ventilation',
        'Modern Design',
        'Energy Efficient Glass'
      ]
    },
    {
      id: 7,
      name: 'Patio Sliding Door',
      category: 'sliding',
      price: 11999.99,
      image: sliding,
      description: 'Wide-view patio door with enhanced security features',
      features: [
        'Large Glass Panels',
        'Smooth Rolling System',
        'Multi-Point Locking',
        'Energy Efficient Design'
      ]
    },
    {
      id: 8,
      name: 'Impact Bay Window',
      category: 'windows',
      price: 13499.99,
      image: win1,
      description: 'Expansive bay window system with hurricane protection',
      features: [
        'Panoramic Views',
        'Built-in Seating Option',
        'Triple Window Design',
        'Superior Insulation'
      ]
    },
    {
      id: 9,
      name: 'Commercial Entry Door',
      category: 'doors',
      price: 9499.99,
      image: hurricane,
      description: 'Heavy-duty commercial grade impact door',
      features: [
        'ADA Compliant',
        'Heavy Duty Hardware',
        'Panic Bar Option',
        'Commercial Grade Finish'
      ]
    }
  ];

  const filteredProducts = selectedCategory === 'all'
    ? products
    : products.filter(product => product.category === selectedCategory);

  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  return (
    <div className="pt-20 md:pt-28 pb-8 md:pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={fadeIn.initial}
          animate={fadeIn.animate}
          transition={fadeIn.transition}
          className="text-center mb-8 md:mb-12"
        >
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
            Our Products
          </h1>
          <p className="text-lg md:text-xl text-gray-600 px-4">
            Browse our selection of high-quality impact windows and doors
          </p>
        </motion.div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-2 md:gap-4 mb-8 md:mb-12 px-2">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`px-4 md:px-6 py-2 rounded-full text-sm font-medium transition duration-300 ${
                selectedCategory === category.id
                  ? 'bg-primary-600 text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {category.name}
            </button>
          ))}
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {filteredProducts.map((product, index) => (
            <motion.div
              key={product.id}
              initial={fadeIn.initial}
              animate={fadeIn.animate}
              transition={{ ...fadeIn.transition, delay: index * 0.1 }}
              className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition duration-300"
            >
              <div className="relative h-48 md:h-64">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-3 md:top-4 right-3 md:right-4 bg-primary-600 text-white px-3 md:px-4 py-1.5 md:py-2 rounded-full text-sm">
                  ${product.price.toLocaleString()}
                </div>
              </div>

              <div className="p-4 md:p-6">
                <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-2">
                  {product.name}
                </h3>
                <p className="text-sm md:text-base text-gray-600 mb-4">
                  {product.description}
                </p>

                <div className="mb-4 md:mb-6">
                  <h4 className="text-sm font-semibold text-gray-900 mb-2">
                    Key Features:
                  </h4>
                  <ul className="space-y-1">
                    {product.features.map((feature, index) => (
                      <li key={index} className="text-xs md:text-sm text-gray-600 flex items-center">
                        <span className="mr-2">•</span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="flex justify-center">
                  <Link
                    to="/get-estimate"
                    className="bg-primary-600 text-white px-4 md:px-6 py-2 rounded-md hover:bg-primary-700 transition duration-300 w-full text-center text-sm md:text-base"
                  >
                    Get Quote
                  </Link>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Call to Action */}
        <motion.div
          initial={fadeIn.initial}
          whileInView={fadeIn.animate}
          viewport={{ once: true }}
          transition={fadeIn.transition}
          className="mt-8 md:mt-16 text-center bg-gray-50 rounded-lg p-6 md:p-8"
        >
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">
            Need Help Choosing the Right Product?
          </h2>
          <p className="text-sm md:text-base text-gray-600 mb-4 md:mb-6">
            Our experts are here to help you select the perfect windows and doors for your home.
          </p>
          <Link
            to="/get-estimate"
            className="inline-block bg-primary-600 text-white px-6 md:px-8 py-2.5 md:py-3 rounded-md text-base md:text-lg font-semibold hover:bg-primary-700 transition duration-300"
          >
            Schedule a Free Consultation
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default Products; 